import { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { X, Heart, Sparkles } from 'lucide-react';

const WelcomePopup = () => {
  const { t, language } = useLanguage();
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Check if user has seen the popup before
    const hasSeenPopup = sessionStorage.getItem('hasSeenWelcomePopup');
    if (!hasSeenPopup) {
      // Show popup after a short delay
      const timer = setTimeout(() => setShowPopup(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setShowPopup(false);
    sessionStorage.setItem('hasSeenWelcomePopup', 'true');
  };

  if (!showPopup) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      data-testid="welcome-popup-overlay"
      onClick={handleClose}
    >
      <div 
        className="relative bg-white rounded-3xl p-8 md:p-12 max-w-lg w-full shadow-2xl animate-float-in"
        style={{ backgroundColor: 'var(--warm-white)' }}
        onClick={(e) => e.stopPropagation()}
        data-testid="welcome-popup"
      >
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Close"
          data-testid="welcome-popup-close"
        >
          <X size={20} className="text-gray-500" />
        </button>

        {/* Content */}
        <div className="text-center">
          {/* Icons */}
          <div className="flex items-center justify-center gap-3 mb-6">
            <Heart size={24} style={{ color: 'var(--sage-500)' }} />
            <Sparkles size={24} style={{ color: 'var(--sand-500)' }} />
          </div>

          {/* Title */}
          <h2 
            className="text-2xl md:text-3xl mb-4"
            style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--charcoal)' }}
          >
            {language === 'he' ? 'ברוך הבא למסע פנימה' : 'Welcome to the Journey Within'}
          </h2>

          {/* Message */}
          <p className="text-gray-600 leading-relaxed mb-8">
            {language === 'he' 
              ? 'שמח שהגעת. נדרש אומץ לצאת למסע של גילוי עצמי ולהתקרב לעצמך.'
              : 'Glad you\'re here. It takes courage to embark on a journey of self-discovery and come closer to yourself.'
            }
          </p>

          {/* CTA Button */}
          <button
            onClick={handleClose}
            className="btn-primary"
            data-testid="welcome-popup-continue"
          >
            {language === 'he' ? 'להמשיך' : 'Continue'}
          </button>
        </div>

        {/* Decorative elements */}
        <div 
          className="absolute -top-4 -left-4 w-16 h-16 rounded-full -z-10 opacity-50"
          style={{ backgroundColor: 'var(--sage-200)' }}
        />
        <div 
          className="absolute -bottom-4 -right-4 w-20 h-20 rounded-full -z-10 opacity-50"
          style={{ backgroundColor: 'var(--sand-200)' }}
        />
      </div>
    </div>
  );
};

export default WelcomePopup;
